import { useQuery } from '@tanstack/react-query';
import { apiListTasks } from '../api/tasks.api';

export function useTasks(projectId: string, params?: Parameters<typeof apiListTasks>[1]) {
    return useQuery({
        queryKey: ['tasks', projectId, params],
        queryFn: () => apiListTasks(projectId, params),
        staleTime: 30_000,
    });
}
